/**
 * Paynow plugin GDPR disclaimer toggle.
 *
 * Plugin używa Bootstrap `data-toggle="collapse"` na `<span class="expand">` żeby
 * zwijać/rozwijać długi tekst RODO. Lokalnie Bootstrap bywa załadowany przez inny plugin,
 * na produkcji / stagingu często brak — wtedy cały RODO jest expandnięty cały czas.
 *
 * Nasz fix: bindiujemy click handler który toggluje `.is-open` na targetowanym
 * elemencie (z `data-target="#paynow_disclaimer_..."`). CSS w _checkout.scss
 * pokazuje `.paynow-data-processing-info-more` tylko z `.is-open`.
 */
export function initPaynowDisclaimer() {
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest && e.target.closest('.paynow-data-processing-info .expand[data-target], .paynow-data-processing-info .expand[data-toggle="collapse"]');
        if (!trigger) return;
        e.preventDefault();

        // `data-target="#paynow_disclaimer_blik"` → znajdź element po ID.
        const targetSel = trigger.getAttribute('data-target');
        let target = null;
        if (targetSel && targetSel.charAt(0) === '#') {
            target = document.getElementById(targetSel.slice(1));
        } else if (targetSel) {
            target = document.querySelector(targetSel);
        }
        // Fallback: sibling `.paynow-data-processing-info-more` w tym samym wrapper'ze.
        if (!target) {
            const wrap = trigger.closest('.paynow-data-processing-info');
            target = wrap ? wrap.querySelector('.paynow-data-processing-info-more') : null;
        }
        if (!target) return;

        const isOpen = target.classList.toggle('is-open');
        // Zaktualizuj label triggera ("Dowiedz się więcej" ↔ "Zwiń").
        const collapsed = trigger.getAttribute('data-collapsed-text') || trigger.textContent.trim();
        const expanded  = trigger.getAttribute('data-expanded-text')  || 'Zwiń';
        // Cache pierwotnego labela żeby revert działał spójnie.
        if (!trigger.dataset.hnOrigLabel) trigger.dataset.hnOrigLabel = collapsed;
        trigger.textContent = isOpen ? expanded : (trigger.dataset.hnOrigLabel || 'Dowiedz się więcej');
    });
}
